var g = function() {
  var e = this, r = e.$createElement, t = e._self._c || r;
  return e.breadcrumbs && e.breadcrumbs.length ? t(e.childComponentName, {
    tag: "component",
    attrs: {
      breadcrumbs: e.breadcrumbs,
      "current-page": e.currentPage
    }
  }) : e._e();
}, p = [];
function v(e, r, t, n, a, d, i, m) {
  var o = typeof e == "function" ? e.options : e;
  r && (o.render = r, o.staticRenderFns = t, o._compiled = !0), n && (o.functional = !0), d && (o._scopeId = "data-v-" + d);
  var u;
  if (i ? (u = function(s) {
    s = s || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !s && typeof __VUE_SSR_CONTEXT__ < "u" && (s = __VUE_SSR_CONTEXT__), a && a.call(this, s), s && s._registeredComponents && s._registeredComponents.add(i);
  }, o._ssrRegister = u) : a && (u = m ? function() {
    a.call(
      this,
      (o.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : a), u)
    if (o.functional) {
      o._injectStyles = u;
      var h = o.render;
      o.render = function(_, f) {
        return u.call(f), h(_, f);
      };
    } else {
      var l = o.beforeCreate;
      o.beforeCreate = l ? [].concat(l, u) : [u];
    }
  return {
    exports: e,
    options: o
  };
}
const $ = {
  name: "BreadcrumbLoader",
  props: {
    childComponentName: {
      type: String,
      required: !0
    },
    slugOverride: {
      type: String,
      required: !1,
      default: null
    },
    currentPage: {
      type: String,
      required: !1,
      default: ""
    }
  },
  computed: {
    breadcrumbs() {
      return this.$store.getters["breadcrumbs/getBreadcrumbForSlug"](this.slug);
    },
    slug() {
      var r, t, n;
      if (this.slugOverride)
        return this.slugOverride;
      const e = this.$store.state.routes.currentRoute;
      if (((r = e == null ? void 0 : e.component) == null ? void 0 : r.component) === "product") {
        const a = this.$store.getters["centra-product/getProductById"](
          (t = e == null ? void 0 : e.component) == null ? void 0 : t.id
        );
        return (n = a == null ? void 0 : a.canonicalUri) != null ? n : this.$route.path;
      } else
        return this.$route.path;
    }
  },
  serverPrefetch() {
    return this.fetchBreadcrumbs();
  },
  mounted() {
    var e;
    (e = this.breadcrumbs) != null && e.length || this.fetchBreadcrumbs();
  },
  methods: {
    fetchBreadcrumbs() {
      return this.$store.dispatch("breadcrumbs/fetchBreadcrumbs", this.slug);
    }
  }
}, b = {};
var S = /* @__PURE__ */ v(
  $,
  g,
  p,
  !1,
  C,
  null,
  null,
  null
);
function C(e) {
  for (let r in b)
    this[r] = b[r];
}
const B = /* @__PURE__ */ function() {
  return S.exports;
}(), L = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B
}, Symbol.toStringTag, { value: "Module" }));
function c(e, r) {
  const t = e.split("/").filter((n) => n !== "");
  return t[0] === r && t.shift(), t.join("/");
}
const y = {
  namespaced: !0,
  state: () => ({
    breadcrumbs: {}
  }),
  mutations: {
    breadcrumb(e, { slug: r, breadcrumb: t }) {
      e.breadcrumbs = {
        ...e.breadcrumbs,
        [r]: t
      };
    }
  },
  actions: {
    async fetchBreadcrumbs({ commit: e, rootState: r, rootGetters: t }, n) {
      n = c(n, t["frontend/currentSiteLangSlug"]);
      try {
        const a = await this.$backendApi.get(
          `breadcrumbs/${r.frontend.currentLanguageCode}/${n}`
        );
        e("breadcrumb", { slug: n, breadcrumb: a.data });
      } catch {
        console.error(
          `Couldn't fetch breadcrumbs for ${r.frontend.currentLanguageCode}/${n}`
        );
      }
    }
  },
  getters: {
    getBreadcrumbForSlug: (e, r, t, n) => (a) => e.breadcrumbs[c(a, n["frontend/currentSiteLangSlug"])]
  }
}, P = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatSlug: c,
  default: y
}, Symbol.toStringTag, { value: "Module" }));
export {
  L as BreadcrumbLoader,
  P as BreadcrumbVuexStore
};
//# sourceMappingURL=breadcrumbs.js.map
